import Filter from '../Filter';

const Post = ({ companyName, jobTitle, isFeatured=false, companyImage, altLogo, postedAt, contract, location, languages, tools, level, role, onFilterClick, isNew=false }) => {
  return (
    <div className="w-4/5 max-w-md mt-12 bg-white rounded-md shadow-lg px-5 pt-10 pb-3 relative xl:flex xl:items-center xl:max-w-5xl xl:mt-5 xl:py-6">
      {
        isFeatured && <div className="w-1.25 h-full absolute top-0 left-0 bg-cyan-desaturated-dark rounded-l-md"></div>
      }
      <img className="w-14 absolute -top-7 xl:relative xl:w-20 xl:h-20 xl:top-0 xl:mr-5" src={companyImage} alt={altLogo} />
      <div>
        <div className="flex items-center">
          <p className="text-cyan-desaturated-dark font-bold text-xs">{companyName}</p>
          {
            isNew && (
              <div className="flex justify-center items-center text-xxs text-white h-6 px-2 bg-cyan-desaturated-dark rounded-full ml-3 font-bold">
                NEW!
              </div>
            )
          }
          {
            isFeatured && (
              <div className="flex justify-center items-center text-xxs text-white px-2 py-1 bg-cyan-very-dark-grayish rounded-full ml-2 font-bold">
                  FEATURED
              </div>
            )
          }
        </div>
        <p className="text-cyan-very-dark-grayish font-semibold text-md my-3 cursor-pointer hover:text-cyan-desaturated-dark">
          {jobTitle}
        </p>
        <div className="flex items-center mb-4 xl:mb-0">
          <p className="text-cyan-dark-grayish text-xs">{postedAt}</p>
          <span className="w-1 h-1 mx-2 bg-cyan-dark-grayish opacity-60 rounded-full"></span>
          <p className="text-cyan-dark-grayish text-xs">{contract}</p>
          <span className="w-1 h-1 mx-2 bg-cyan-dark-grayish opacity-60 rounded-full"></span>
          <p className="text-cyan-dark-grayish text-xs">{location}</p>
        </div>
      </div>
      <hr className="mb-4 text-cyan-dark-grayish text-opacity-50 Xl:hidden" />

      {/* Filter */}
      <div className="flex flex-wrap xl:items-center xl:ml-auto">
        {
          [role, level, ...languages, ...tools].map(info => (
            <div className="mr-3 mb-3 xl:mb-0" key={info}>
              <Filter
                name={info}
                onFilterClick={onFilterClick}
              />
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default Post;
